import { polaritiesOf } from '@voll-intelligence/domain';
import { defaultSel as kitDefaultSel, type FareSel } from '@voll-intelligence/intelligence-ui-kit';
import type { FlightTariffView } from '@voll-intelligence/genui-contract';

export { comboFares, type FareSel } from '@voll-intelligence/intelligence-ui-kit';

/*
 * A aritmética da seleção de tarifas mora no intelligence-ui-kit (#4997). Este
 * módulo liga o classificador do domain ao default da seleção, que os cards do
 * chat e o explorer ainda leem pelo caminho antigo.
 */
export function defaultSel(view: FlightTariffView): FareSel {
  return kitDefaultSel(view, polaritiesOf);
}
